// ==============================|| VERSION DE LA APLICACION ||============================== //
// Fuente unica: el campo "version" de package.json, inyectado en build time
// por `define.__APP_VERSION__` en vite.config.mts.

export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0';

/** Version lista para mostrar en UI, p. ej. "v0.9.0". */
export const APP_VERSION_LABEL = `v${APP_VERSION}`;
